import { render, staticRenderFns } from "./dateForm.vue?vue&type=template&id=1b994f24&scoped=true"
import script from "./dateForm.vue?vue&type=script&lang=js"
export * from "./dateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b994f24",
  null
  
)

export default component.exports